var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 21.1333C18.8789 22.9209 16.128 24 13.1221 24C6.41483 24 0.977539 18.6274 0.977539 12C0.977539 5.37258 6.41483 0 13.1221 0C16.128 0 18.8789 1.07912 20.9996 2.86669C23.1203 1.07912 25.8712 0 28.8772 0C35.5845 0 41.0217 5.37258 41.0217 12C41.0217 18.6274 35.5845 24 28.8772 24C25.8712 24 23.1203 22.9209 20.9996 21.1333Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.1333C23.6112 18.9322 25.2669 15.6572 25.2669 12C25.2669 8.34282 23.6112 5.06776 21 2.86674C23.1207 1.07914 25.8716 0 28.8776 0C35.5849 0 41.0222 5.37258 41.0222 12C41.0222 18.6274 35.5849 24 28.8776 24C25.8716 24 23.1207 22.9209 21 21.1333Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9994 21.1338C23.6106 18.9328 25.2663 15.6577 25.2663 12.0005C25.2663 8.3433 23.6106 5.06821 20.9994 2.86719C18.3882 5.06821 16.7324 8.3433 16.7324 12.0005C16.7324 15.6577 18.3882 18.9328 20.9994 21.1338Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMastercard);
export default __webpack_public_path__ + "static/media/card-mastercard.dad40198ad01398679db1a5592f6e0be.svg";
export { ForwardRef as ReactComponent };